import { createFileRoute } from '@tanstack/react-router'
import { AssetsImportPage } from '../../../components/AssetsImportPage'

export const Route = createFileRoute('/$org/data/import')({
  component: DataImport,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      jobUid: (search.jobUid as string) || undefined,
    }
  },
})

function DataImport() {
  const searchParams = Route.useSearch()
  return <AssetsImportPage jobUid={searchParams.jobUid} />
}
